<template>
  <div :class="{ 'd-inline': inline }" data-testid="BaseModal">
    <slot :onOpen="onOpen" name="trigger" />
    <!-- 'no-enforce-focus' option allows focusing to CKEdtior link popup -->
    <b-modal
      ref="theModal"
      v-model="show"
      v-bind="{ ...modalProps, 'no-enforce-focus': true }"
      lazy
      @hidden="afterClose"
    >
      <template slot="modal-header">
        <h4 class="h5 m-0">{{ title }}</h4>
        <b-btn
          v-if="showCloseOnHeader"
          aria-label="Close"
          type="button"
          class="close"
          @click="onClose"
        >
          &times;
        </b-btn>
      </template>
      <template v-if="show" slot="default">
        <slot :onClose="onClose" />
      </template>

      <template slot="modal-footer">
        <slot :onClose="onClose" name="footer">
          <b-row>
            <b-col class="BaseModal__footer">
              <BaseModalControls :onOk="onClose" :onCancel="onClose" />
            </b-col>
          </b-row>
        </slot>
      </template>
    </b-modal>
  </div>
</template>

<script>
import uuid from 'uuid'
import BaseModalControls from './BaseModalControls/BaseModalControls'

export default {
  components: {
    BaseModalControls
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    modalProps: {
      type: Object,
      default() {
        return {}
      }
    },
    afterClose: {
      type: Function,
      default: () => {}
    },
    initOpen: {
      type: Boolean,
      default: false
    },
    showCloseOnHeader: {
      type: Boolean,
      default: true
    },
    inline: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      id: uuid(),
      show: this.initOpen
    }
  },
  methods: {
    onOpen() {
      this.show = true
    },
    onClose() {
      this.show = false
    }
  }
}
</script>
